"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMiscList = exports.isLunchList = exports.isRetailList = exports.ListType = void 0;
var ListType;
(function (ListType) {
    ListType["retail"] = "retail";
    ListType["lunch"] = "lunch";
    ListType["fish"] = "fish";
    ListType["meat"] = "meat";
})(ListType = exports.ListType || (exports.ListType = {}));
/** TYPEGUARDS for Lists */
exports.isRetailList = (list) => (list === null || list === void 0 ? void 0 : list.type) === ListType.retail;
exports.isLunchList = (list) => (list === null || list === void 0 ? void 0 : list.type) === ListType.lunch;
exports.isMiscList = (list) => (list === null || list === void 0 ? void 0 : list.type) === ListType.meat || (list === null || list === void 0 ? void 0 : list.type) === ListType.fish;
//# sourceMappingURL=lists.js.map